import { useId } from "react";
import { Link } from "react-router-dom";

const CUTS = (
  <>
    <path fill="#fff" d="M12 12 H72 A32 32 0 0 1 72 76 H50 V108 H12 Z" />
    <path fill="#000" d="M50 32 H62 A10 10 0 0 1 62 56 H50 Z" />
    <rect x="22" y="16" width="4" height="92" fill="#000" />
    <rect x="36" y="16" width="4" height="92" fill="#000" />
    <polygon points="12,62 50,20 50,30 12,72" fill="#000" />
  </>
);

export function LogoMark({ dark = false, className = "" }) {
  const id = useId().replace(/:/g, "");
  return (
    <svg viewBox="0 0 120 120" className={className} aria-hidden="true">
      <defs><mask id={`pbs-cut-${id}`}>{CUTS}</mask></defs>
      <rect width="120" height="120" fill={dark ? "#FFFFFF" : "#236B45"} mask={`url(#pbs-cut-${id})`} />
      <polygon points="40,41 50,30 50,108 40,108" fill="#C9A45C" />
    </svg>
  );
}

export function LogoIcon({ className = "" }) {
  const id = useId().replace(/:/g, "");
  return (
    <svg viewBox="0 0 512 512" className={className} aria-hidden="true">
      <rect width="512" height="512" rx="112" fill="#236B45" />
      <defs><mask id={`pbs-icon-${id}`}>{CUTS}</mask></defs>
      <g transform="translate(66 66) scale(3.16667)">
        <rect width="120" height="120" fill="#FFFFFF" mask={`url(#pbs-icon-${id})`} />
        <polygon points="40,41 50,30 50,108 40,108" fill="#C9A45C" />
      </g>
    </svg>
  );
}

export const Logo = ({ light = false, tagline = false, className = "" }) => (
  <Link to="/" data-testid="header-logo" className={`flex items-center gap-3 group ${className}`}>
    <LogoMark dark={light} className="h-9 w-9 shrink-0 transition-transform duration-200 group-hover:scale-105" />
    <span className="leading-none">
      <span className="block font-extrabold text-xl tracking-tight whitespace-nowrap">
        <span className={light ? "text-white" : "text-pbs-plum"}>PlotBy</span><span className="text-pbs-gold">Square</span>
      </span>
      {tagline && (
        <span className={`block mt-1.5 text-[9px] font-semibold tracking-[0.26em] whitespace-nowrap ${light ? "text-white/70" : "text-pbs-dark/60"}`}>
          REAL ESTATE. HIGHER POSSIBILITIES.
        </span>
      )}
    </span>
  </Link>
);

export default Logo;
